import { SelectPlus } from 'Components/SelectPlus';

const SERVICE_TYPE_OPTIONS = [
  { label: 'Particular', value: 'Particular' },
  { label: 'Público', value: 'Publico' },
];

export const SelectServiceType = ({ mode = 'single', ...selectProps }) => {
  const isSingleMode = mode === 'single';
  const placeholder = `Seleccionar ${isSingleMode ? 'tipo de servicio' : 'tipos de servicio'}`;

  return (
    <SelectPlus
      mode={mode}
      placeholder={placeholder}
      options={SERVICE_TYPE_OPTIONS}
      {...selectProps}
    />
  );
};